import Menu from 'antd-core/es/menu';
import styled, { css } from 'styled-components';

const colorized = (color) => {
    if (!color)
        return;
    if (color === null || color === void 0 ? void 0 : color.includes('gradient'))
        return css `
      background: ${color};
      background-clip: text;
      -webkit-text-fill-color: transparent;
    `;
    return css `
    color: ${color};
  `;
};
const Root = styled(Menu) `
  &.tend-ui-menu-horizontal {
    min-width: 0;
    flex: auto;
    margin-right: 275px;

    height: 24px;
    line-height: 1;
    border-bottom: none;

    .tend-ui-menu-item,
    .tend-ui-menu-submenu {
      padding: 2px 8px;
      display: flex;
      align-items: center;
      gap: 8px;

      /* Стили на пункт меню с children еще "Еще" */
      .tend-ui-menu-submenu-title {
        color: ${props => props.$styling.defaultText};
      }
      &:not(.tend-ui-menu-item-selected, .tend-ui-menu-submenu-selected) {
        background: ${props => props.$styling.tabDefaultBg};
        .tend-ui-menu-item-label {
          ${props => colorized(props.$styling.defaultText)};
        }
        .tend-ui-icon-root {
          color: ${props => props.$styling.tabDefaultIcon};
        }
      }

      &:hover {
        .tend-ui-menu-item-label {
          -webkit-text-fill-color: unset;
          color: ${props => props.$styling.hoverText};
        }
        .tend-ui-icon-root {
          color: ${props => props.$styling.tabHoverIcon};
        }

        /* Стили на пункт меню с children еще "Еще" */
        .tend-ui-menu-submenu-title {
          color: ${props => props.$styling.hoverText} !important;
        }

        background: ${props => props.$styling.tabHoverBg};
      }

      &.tend-ui-menu-item-selected,
      &.tend-ui-menu-submenu-selected {
        color: ${props => props.$styling.activeText};
        .tend-ui-menu-submenu-title {
          color: ${props => props.$styling.activeText};
        }
        background: ${props => props.$styling.tabActiveBg};

        &:hover {
          background: ${props => props.$styling.tabActiveHoverBg};
        }
      }

      &:first-child {
        margin-right: 4px;
      }
      &:last-child {
        margin-left: 4px;
      }
      &:not(:first-child):not(:last-child) {
        margin-left: 4px;
        margin-right: 4px;
      }

      /*
        Antd вешает стили из меню на span рядом с классом .anticon. Переопределяем
      */
      .tend-ui-menu-item .tend-ui-menu-item-icon + .tend-ui-badge-root,
      .tend-ui-menu-submenu-title .tend-ui-menu-item-icon + .tend-ui-badge-root,
      .tend-ui-menu-item .anticon + .tend-ui-badge-root,
      .tend-ui-menu-submenu-title .anticon + .tend-ui-badge-root {
        margin-inline-start: 0px;
      }
    }

    /* Пункт меню без children hover */
    .tend-ui-menu-overflow-item.tend-ui-menu-item-active {
      .tend-ui-dot-dot {
        background: ${props => props.$theme.colors['white700-transparent']};
      }
      .tend-ui-counter-counter {
        color: ${props => props.$theme.colors.blue700};
        background: ${props => props.$theme.colors['white700-transparent']};
      }
    }
    /* Пункт меню без children selected */
    .tend-ui-menu-overflow-item.tend-ui-menu-item-selected {
      .tend-ui-dot-dot {
        background: ${props => props.$theme.colors['white700-transparent']};
      }
      .tend-ui-counter-counter {
        color: ${props => props.$theme.colors.blue700};
        background: ${props => props.$theme.colors['white700-transparent']};
      }
    }
    /* Пункт меню с children hover */
    .tend-ui-menu-overflow-item.tend-ui-menu-submenu-active {
      .tend-ui-dot-dot {
        background: ${props => props.$theme.colors['white700-transparent']};
      }
      .tend-ui-counter-counter {
        color: ${props => props.$theme.colors.blue700};
        background: ${props => props.$theme.colors['white700-transparent']};
      }
    }
    /* Пункт меню с children selected */
    .tend-ui-menu-overflow-item.tend-ui-menu-submenu-selected {
      .tend-ui-dot-dot {
        background: ${props => props.$theme.colors['white700-transparent']};
      }
      .tend-ui-counter-counter {
        color: ${props => props.$theme.colors.blue700};
        background: ${props => props.$theme.colors['white700-transparent']};
      }
    }
  }
`;

export { Root };
